import { render } from "./MenubarSub.vue?vue&type=template&id=71c1fbc2"
import script from "./MenubarSub.vue?vue&type=script&lang=js"
export * from "./MenubarSub.vue?vue&type=script&lang=js"
script.render = render

export default script